import {
  QuoteCoverageTableHeadings,
  QuoteCoverageTableContent,
} from '../components/BenefitsTable/BenefitsTable.types';

export const quoteCoverageTableHeadings: QuoteCoverageTableHeadings[] = [
  {
    heading: 'Standard warranty',
    description: 'Only valid for 1 year from purchase',
    type: 'included',
  },
  {
    heading: 'Extra protection ',
    description: 'Continues as long as you want',
    type: 'extra',
  },
];
export const quoteCoverageTableContent: QuoteCoverageTableContent[] = [
  {
    type: 'Breakdown cover',
    standard: {
      included: true,
      description: '',
    },
    extra: {
      included: true,
      description: 'Coverage for mechanical or electrical faults with no hidden costs',
    },
  },
  {
    type: 'Accidental damage cover',
    standard: {
      included: false,
      description: '',
    },
    extra: { included: true, description: 'Coverage for drops and spills with no hidden costs' },
  },

  {
    type: 'Accessory replacement',
    standard: {
      included: false,
      description: 'Only for breakdowns',
    },
    extra: {
      included: true,
      description: 'Replacement for broken shelves, drawers and seals with no hidden costs',
    },
  },
  {
    type: 'Unlimited repairs',
    standard: {
      included: false,
      description: 'Only for breakdowns',
    },
    extra: {
      included: true,
      description: 'Coverage with no hidden costs, call out fees or deductibles',
    },
  },
  {
    type: 'Brand new replacement',
    standard: { included: false, description: 'Only for breakdowns' },
    extra: { included: true, description: 'If we can’t fix it, we’ll replace it' },
  },
];
